<template>
  <div id="basicqulityRef">
    <div class="top_line">
        <span class="mainName">{{basicQulityForm?basicQulityForm.baseInfo.mainName:'--'}}</span>
      </div>
    <el-form
      :model="basicQulityForm"
      :rules="rules"
      ref="basicQulityRef"
      label-width="180px"
      class="basicQulityClass"
      v-loading="loadingFlag"
    >
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>企业基本素质</span>
        </div>
        <div class="card-content">
          <el-row>
            <el-col :span="12">
              <el-row>
                <el-col>
                  <el-form-item ref="mainCode" label="企业名称：" prop="mainCode" size="small">
                    <span>{{basicQulityForm?basicQulityForm.baseInfo.mainName:'--'}}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item ref="mainCode" label="统一社会信用代码：" prop="mainCode" size="small">
                    <span>{{basicQulityForm?basicQulityForm.baseInfo.mainCode:'--'}}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item ref="mainCode" label="成立日期：" prop="mainCode" size="small">
                    <span>{{basicQulityForm?basicQulityForm.baseInfo.incorporationTime:'--'}}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item ref="mainCode" label="注册资本：" prop="mainCode" size="small">
                    <span>{{basicQulityForm?basicQulityForm.baseInfo.registerCapital:'--'}}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item ref="mainCode" label="企业类型：" prop="mainCode" size="small">
                    <span>{{basicQulityForm?basicQulityForm.baseInfo.companyTypeName:'--'}}</span>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col>
                  <el-form-item ref="mainCode" label="国民经济行业分类：" prop="mainCode" size="small">
                    <span>{{basicQulityForm?basicQulityForm.baseInfo.industryCodeName:'--'}}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item ref="mainCode" label="法定代表人：" prop="mainCode" size="small">
                    <span>{{basicQulityForm?basicQulityForm.baseInfo.entContactVo.orgLegal:'--'}}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <!-- 营业执照 -->
            <el-col :span="12">
              <!-- {{'----'}} -->
              <el-form-item
                v-for="(item,index) in (basicQulityForm?basicQulityForm.baseInfo.attachments:[])"
                :label="item.remark?(item.remark+'：'):'附件：'"
                :key="index"
                v-if="item.fileType==2" 
              >

                <imgUploadView
                  :backgroundType="1"
                  :fileName.sync="item.name"
                  :imgUrl.sync="item.filePath"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item ref="mainCode" label="注册地址：" prop="mainCode" size="small">
                <span>{{basicQulityForm?basicQulityForm.baseInfo.addressDetail:'--'}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-row>
              <el-col>
                <el-form-item ref="mainCode" label="经营范围：" prop="mainCode" size="small">
                  <span>{{basicQulityForm?basicQulityForm.baseInfo.businessScope:'--'}}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-row>
          <!-- 法定代表人身份信息： -->
          <el-row>
            <el-col :span="12">
              <el-form-item
              v-if="item.fileType==3"
                v-for="(item,index) in (basicQulityForm?basicQulityForm.baseInfo.attachments:[])"
                :label="item.remark?(item.remark+'：'):'附件：'"
                :key="index"
              >
                <imgUploadView
                  :backgroundType="3"
                  :fileName.sync="item.name"
                  :imgUrl.sync="item.filePath"
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                v-for="(item,index) in (basicQulityForm?basicQulityForm.baseInfo.attachments:[])"
                :label="item.remark?(item.remark+'：'):'附件：'"
                :key="index"
                v-if="item.fileType==4"
              >
                <imgUploadView
                  :backgroundType="2"
                  :fileName.sync="item.name"
                  :imgUrl.sync="item.filePath"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- <el-row>
          <el-col :span="12">
            <el-form-item ref="mainCode" label="法人机构类别：" prop="mainCode" size="small">
              <span>{{basicQulityForm?basicQulityForm.baseInfo.agencyCodeName:'--'}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item ref="mainCode" label="营业执照：" prop="mainCode" size="small">
              <span>{{basicQulityForm?basicQulityForm.baseInfo.mainCode:'--'}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item ref="mainCode" label="证书名称：" prop="mainCode" size="small">
              <span>{{basicQulityForm?basicQulityForm.baseInfo.certName:'--'}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item ref="mainCode" label="证书编号：" prop="mainCode" size="small">
              <span>{{basicQulityForm?basicQulityForm.baseInfo.certNum:'--'}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item ref="mainCode" label="颁发部门：" prop="mainCode" size="small">
              <span>{{basicQulityForm?basicQulityForm.baseInfo.awardDepart:'--'}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item ref="mainCode" label="颁发日期" prop="mainCode" size="small">
              <span>{{basicQulityForm?basicQulityForm.baseInfo.awardTime:'--'}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item ref="mainCode" label="证书有效期限至：" prop="mainCode" size="small">
              <span>{{basicQulityForm?basicQulityForm.baseInfo.businessFailTime:'--'}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item ref="mainCode" label="国别/地区：" prop="mainCode" size="small">
              <span>{{basicQulityForm?basicQulityForm.baseInfo.nationName:'--'}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item ref="mainCode" label="注册资本：" prop="mainCode" size="small">
              <span>{{basicQulityForm?basicQulityForm.baseInfo.registerCapital:'--'}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item ref="mainCode" label="成立日期：" prop="mainCode" size="small">
              <span>{{basicQulityForm?basicQulityForm.baseInfo.incorporationTime:'--'}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row></el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item ref="mainCode" label="单位地址：" prop="mainCode" size="small">
              <span>{{basicQulityForm?basicQulityForm.baseInfo.addressCodeName:'--'}}</span>
            </el-form-item>
          </el-col>
        </el-row>
          -->
          <!-- 待处理 -->
          <el-row>
            <el-col :span="12">
              <el-form-item ref="mainCode" label="法定代表人手机号" prop="mainCode" size="small">
                <span>{{basicQulityForm?basicQulityForm.baseInfo.entContactVo.orgLegalTel:'--'}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item ref="mainCode" label="法定代表人证件信息：" prop="mainCode" size="small">
                <span>{{basicQulityForm?basicQulityForm.baseInfo.entContactVo.orgCertType:'--'}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item ref="mainCode" label="法定代表人证件号码：" prop="mainCode" size="small">
                <span>{{basicQulityForm?basicQulityForm.baseInfo.entContactVo.legalIdCard:'--'}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item ref="mainCode" label="负责人" prop="mainCode" size="small">
                <span>{{basicQulityForm?basicQulityForm.baseInfo.entContactVo.responsible:'--'}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item ref="mainCode" label="负责人手机号：" prop="mainCode" size="small">
                <span>{{basicQulityForm?basicQulityForm.baseInfo.entContactVo.linkPhone:'--'}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col>
                  <el-form-item
                    v-for="(item,index) in (basicQulityForm?basicQulityForm.baseInfo.attachments:[])"
                    :label="item.remark?(item.remark+'：'):'附件：'"
                    :key="index"
                    v-if="item.fileType==2"
                  >
                    <imgUploadView
                      :backgroundType="1"
                      :fileName.sync="item.name"
                      :imgUrl.sync="item.filePath"
                    />
                  </el-form-item>
                </el-col>
          </el-row> -->
          <!-- 法定代表人身份附件： -->
          <!-- <el-row>
            <el-row>
              <el-row>
                <el-col>
                  <el-form-item
                    v-for="(item,index) in (basicQulityForm?basicQulityForm.baseInfo.attachments:[])"
                    :label="item.remark?(item.remark+'：'):'附件：'"
                    :key="index"
                    v-if="item.fileType==3"
                  >
                    <imgUploadView
                      :backgroundType="2"
                      :fileName.sync="item.name"
                      :imgUrl.sync="item.filePath"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item
                    v-for="(item,index) in (basicQulityForm?basicQulityForm.baseInfo.attachments:[])"
                    :label="item.remark?(item.remark+'：'):'附件：'"
                    :key="index"
                    v-if="item.fileType==4"
                  >
                  {{item.fileType}}--
                    <imgUploadView
                      :backgroundType="2"
                      :fileName.sync="item.name"
                      :imgUrl.sync="item.filePath"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-row>
          </el-row> -->
        </div>
      </el-card>
    </el-form>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    dataObj: {
      type: Object,
      default: () => {}
    },
    attachments: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loadingFlag: false,
      basicQulityForm: {},
      rules: {},
      allAttachmentsObj: {},
      ent_base_attachments: []
    };
  },
  computed: {
    ...mapState({
      entBaseAttConfig: state => {
        console.log(state, 111);
        return state.dataDictionary.entBaseAttConfig;
      }
    })
  },
  watch: {
    dataObj: {
      deep: true,
      immediate: true,
      handler(val) {
        this.basicQulityForm = val.chapter1;
      }
    },
    attachments: {
      deep: true,
      immediate: true,
      handler(val) {
        this.allAttachmentsObj = val;
        this.ent_base_attachments =
          this.allAttachmentsObj.ent_base_info_att || [];
      }
    }
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
#basicqulityRef{
  border: 1px solid #d8d8d8;
    height: 1520px;
  .top_line {
      width: 80%;
      height: 50px;
      color: #8a8a8a;
      margin: 0 auto;
      border-bottom: 1px solid #d8d8d8;
      position: relative;
      .mainName {
        position: absolute;
        bottom: 10px;
        right: 0;
      }
    }
}
</style>